import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';
import AlertMessage from '../../AlertMessage';

const PersonalData = () => {
  const [classValue, setClassValue] = useState('');
  const [divisionValue, setDivisionValue] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [heightWeight, setHeightWeight] = useState({});
  const [alertMessage, setAlertMessage] = useState("");  
  const [showAlert, setShowAlert] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem('language') || 'English';
  const [selectedMonth, setSelectedMonth] = useState('');
  

  useEffect(() => {
    fetchStudentData();
  }, []);

  const months = ["June", "September", "December", "March"];

  const sortClasses = (classes, language) => {
    const classOrder = {
      "Class I": 1,
      "Class II": 2,
      "Class III": 3,
      "Class IV": 4,
      "Class V": 5,
      "Class VI": 6,
      "Class VII": 7,
      "Class VIII": 8,
      "Class IX": 9,
      "Class X": 10,
      "Class XI": 11,
      "Class XII": 12,
      "इयत्ता पहिली": 1,
      "इयत्ता दुसरी": 2,
      "इयत्ता तिसरी": 3,
      "इयत्ता चौथी": 4,
      "इयत्ता पाचवी": 5,
      "इयत्ता सहावी": 6,
      "इयत्ता सातवी": 7,
      "इयत्ता आठवी": 8,
      "इयत्ता नववी": 9,
      "इयत्ता दहावी": 10,
      "इयत्ता अकरावी": 11,
      "इयत्ता बारावी": 12,
    };
  
    return classes.sort((a, b) => classOrder[a] - classOrder[b]);
  };

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); 

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('schoolData')) {
          db.createObjectStore('schoolData', { keyPath: 'udiseNumber' });
        }
      };
    });
  };

   const [classes, setClasses] = useState([]); // To hold class names
   const [divisions, setDivisions] = useState({}); // To hold divisions for each class
   const [year, setYear] = useState('2024-2025');
   
     useEffect(() => {
       const fetchDefaultYear = async () => {
         try {
           const db = await openIndexedDB();
           const transaction = db.transaction(['defaultSettings'], 'readonly');
           const objectStore = transaction.objectStore('defaultSettings');
           const request = objectStore.get('defaultSettings');
       
           request.onsuccess = (event) => {
             const defaultSetting = event.target.result;
             
             if (defaultSetting) {
               setYear(defaultSetting.defaultYear || "");
             } else {
               console.warn("No default settings found for the key 'defaultSettings'.");
             }
           };
           request.onerror = (event) => {
             console.error("Error fetching default settings:", event.target.error);
           };
         } catch (error) {
           console.error('Error fetching default year:', error);
         }
       };
       fetchDefaultYear();
     }, [udiseNumber]);
   

  const fetchClassDivData = async () => {
    try {
      const storedDivClasses = localStorage.getItem("classDiv");
      if (storedDivClasses) {
        const data = JSON.parse(storedDivClasses);
        
        const classList = [];
        const divisionList = {};
    
        for (const [className, value] of Object.entries(data)) {
          if (value === true) {
            classList.push(className);
            divisionList[className] = []; // Initialize with an empty array
          } else if (typeof value === 'object') {
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
          }
        }
    
        setClasses(classList);
        setDivisions(divisionList); // Set the divisionList as the state
      }
    } catch (error) {
      console.error("Error fetching classDiv data: ", error);
    }
  };

    useEffect(() => {
      fetchClassDivData();
    }, [udiseNumber]);


    const fetchStudentData = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['studentData'], 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const allRecords = objectStore.getAll();
    
        allRecords.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            const filteredData = Object.keys(data)
              .filter(key => data[key] !== null)
              .map(key => ({
                srNo: key, 
                ...data[key]
              }));
    
            setStudentData(filteredData);
    
            const heightWeightData = {};
            filteredData.forEach(student => {
              // Check if weightandHeight exists and if the year exists
              const weightAndHeightForYear = student.weightandHeight ? student.weightandHeight[year] : null;
    
              heightWeightData[student.srNo] = {
                height: weightAndHeightForYear && weightAndHeightForYear[selectedMonth] ? weightAndHeightForYear[selectedMonth].height : '', // Default to empty string if not found
                weight: weightAndHeightForYear && weightAndHeightForYear[selectedMonth] ? weightAndHeightForYear[selectedMonth].weight : ''  // Default to empty string if not found
              };
            });
            setHeightWeight(heightWeightData);
          }
        };
    
        allRecords.onerror = (event) => {
          console.error('Error fetching student data from IndexedDB:', event.target.error);
        };
      } catch (error) {
        console.error('Error fetching student data:', error);
      }
    };
  

    const filteredStudentData = studentData.filter(student => {
      const classMatch = classValue ? student.currentClass === classValue : true;
      const divisionMatch = divisionValue ? student.division === divisionValue : true;
      const activeMatch = student.isActive !== false || student.isActive === undefined; // Only include active students
      return classMatch && divisionMatch && activeMatch;
    });
  
  const [allDivisions, setAllDivisions] = useState([]);
  const handleClassChange = (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass);
setDivisionValue('')
    if (selectedClass && divisions[selectedClass]) {
      const filteredDivisions = divisions[selectedClass].filter(div => div);
    setAllDivisions(filteredDivisions);
  } else {
    setAllDivisions([]);
  }
  };

  const handleDivisionChange = (e) => {
    setDivisionValue(e.target.value);
  };


  const handleMonthChange = (e) => {
    const month = e.target.value;
    setSelectedMonth(month);
  
    const updatedHeightWeight = { ...heightWeight };
    studentData.forEach(student => {
      // Check if weightandHeight exists and if the year exists
      const weightAndHeightForYear = student.weightandHeight ? student.weightandHeight[year] : null;
  
      // Only update if weightAndHeightForYear and the selected month exist
      if (weightAndHeightForYear && weightAndHeightForYear[month]) {
        updatedHeightWeight[student.srNo] = {
          height: weightAndHeightForYear[month].height || '',
          weight: weightAndHeightForYear[month].weight || ''
        };
      } else {
        // If the data doesn't exist, set height and weight to empty strings
        updatedHeightWeight[student.srNo] = {
          height: '',
          weight: ''
        };
      }
    });
    setHeightWeight(updatedHeightWeight);
  };
  const handleHeightWeightChange = (srNo, field, value) => {
    // Ensure we're dealing with a string
    const valueStr = value.toString();
    
    // Only allow numeric values or empty string
    const newValue = valueStr.trim() === "" 
      ? "" 
      : (field === "height" || field === "weight") && !isNaN(parseFloat(valueStr)) 
        ? parseFloat(valueStr) 
        : valueStr;
    
    // console.log(`Updating ${field} for student ${srNo} to ${newValue}`);
  
    setHeightWeight((prevState) => {
      const updatedState = { ...prevState };
      updatedState[srNo] = updatedState[srNo] || {};
      updatedState[srNo][field] = newValue;
      
      // Log the updated state for this student
      // console.log(`Updated heightWeight state for student ${srNo}:`, updatedState[srNo]);
      
      return updatedState;
    });
  };


  const saveHeightWeight = async () => {
    if (!classValue || !selectedMonth) {
      return alert('Please select required fields.');
    }
  
    try {
      const updateBatch = [];
  
      for (const student of filteredStudentData) {
        const srNo = student.srNo;
        const studentKey = student.id;
        const numericSrNo = studentKey.split('-').pop();
        if (heightWeight[srNo] && (heightWeight[srNo].height || heightWeight[srNo].weight)) {
          const { height, weight } = heightWeight[srNo];
          updateBatch.push({
            studentKey,
            srNo: numericSrNo,
            originalSrNo: srNo,
            height,
            weight
          });
        }
      }
  
      if (updateBatch.length === 0) {
        setAlertMessage('No data was updated. Please enter height and weight values.');
        setShowAlert(true);
        return;
      }
  
      const firebaseUrl = process.env.REACT_APP_FIREBASE_DATABASE_URL;
  
      const firebasePromises = updateBatch.map(async (student) => {
        const res = await fetch(`${firebaseUrl}/schoolRegister/${udiseNumber}/studentData/${student.srNo}/weightandHeight/${year}/${selectedMonth}.json`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            height: student.height,
            weight: student.weight,
          }),
        });
  
        if (!res.ok) {
          console.error(`Failed to update Firebase for ${student.srNo}:`, await res.text());
        }
  
        return res;
      });
  
      await Promise.all(firebasePromises);
  
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readwrite');
      const objectStore = transaction.objectStore('studentData');
  
      let successCount = 0;
  
      for (const student of updateBatch) {
        const studentData = await new Promise((resolve, reject) => {
          const request = objectStore.get(student.studentKey);
          request.onsuccess = () => resolve(request.result);
          request.onerror = () => reject(request.error);
        });
  
        if (studentData) {
          // Initialize weightandHeight if it doesn't exist
          studentData.weightandHeight = studentData.weightandHeight || {};
          // Initialize the year if it doesn't exist
          studentData.weightandHeight[year] = studentData.weightandHeight[year] || {};
  
          // Set the height and weight for the selected month
          studentData.weightandHeight[year][selectedMonth] = {
            height: student.height,
            weight: student.weight,
          };
  
          const updateRequest = objectStore.put(studentData);
          await new Promise((resolve, reject) => {
            updateRequest.onsuccess = () => {
              successCount++;
              resolve();
            };
            updateRequest.onerror = (event) => reject(event.target.error);
          });
        } else {
          console.error(`Student not found `);
        }
      }
  
      transaction.oncomplete = () => {
        setAlertMessage(`Height and weight saved for students!`);
        setShowAlert(true);
        fetchStudentData(); // Refresh
      };
  
      transaction.onerror = (event) => {
        console.error('Transaction error:', event.target.error);
      };
  
    } catch (error) {
      console.error('Error saving height and weight:', error);
      setAlertMessage('Error occurred while saving data.');
      setShowAlert(true);
    }
  }
  

  
  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div className='main-content-of-page text-center'>
        <h3 className='text-center mb-4' style={{ color:'#1B4332', fontWeight:'600'}}>{language === "English" ? "Student Height and Weight" : "विद्यार्थ्यांची उंची आणि वजन"}</h3>

        <table className="table" style={{ width: '50%' }}>
          <tbody>
            <tr>
              <th>{language === "English" ? "Class" : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
                  {sortClasses(classes.filter(cls => cls.trim() !== ""), language).map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            <tr>
              <th>{language === "English" ? "Division" : "तुकडी"}</th>
              <td>
                <select
                  id="division"
                  value={divisionValue}
                  onChange={handleDivisionChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Division" : "तुकडी निवडा"}</option>
                  {allDivisions.map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            <tr>
              <th>{language === "English" ? "Month" : "महिना"}</th>
              <td>
                <select
                  id="month"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Month" : "महिना निवडा"}</option>
                  {months.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          </tbody>
        </table>

        <div className='mt-5'>
          <button onClick={saveHeightWeight} className="btn btn-primary">
            {language === "English" ? "Save Height and Weight" : "उंची आणि वजन जतन करा"}
          </button>
        </div>

        {/* Show students and input fields for height and weight */}
        {studentData.length > 0 && (
          <div className="mt-4">
            <h5 style={{ fontWeight: '600' }}>{language === "English" ? "Students List" : "विद्यार्थ्यांची यादी"}</h5>
            <table className="table ">
              <thead>
                <tr>
                  <th>{language === "English" ? "Roll No" : "हजेरी  क्र."}</th>
                  <th>{language === "English" ? "Class" : "वर्ग"}</th>
                  <th>{language === "English" ? "Division" : "तुकडी"}</th>
                  <th>{language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                  <th>{language === "English" ? "Height (cm)" : "उंची (सेमी)"}</th>
                  <th>{language === "English" ? "Weight (kg)" : "वजन (किलो)"}</th>
                  <th>BMI</th>
                </tr>
              </thead>
              <tbody>
                {filteredStudentData.map((student) => (
                  <tr key={student.srNo}>
                    <td>{student.rollNo}</td>
                    <td>{student.currentClass}</td>
                    <td>{student.division}</td>
                    <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                    <td>
                      <input
                        type="number"
                        value={heightWeight[student.srNo]?.height || ""} // Fetch height from the heightWeight state
                        onChange={(e) => handleHeightWeightChange(student.srNo, "height", e.target.value)}
                        className="form-control"
                        placeholder={language === "English" ? "Enter Height" : "उंची भरा"}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={heightWeight[student.srNo]?.weight || ""} // Fetch weight from the heightWeight state
                        onChange={(e) => handleHeightWeightChange(student.srNo, "weight", e.target.value)}
                        className="form-control"
                        placeholder={language === "English" ? "Enter Weight" : "वजन भरा"}
                      />
                    </td>
                    <td>
                      {/* BMI Calculation can be added here if needed */}
                      {heightWeight[student.srNo]?.height && heightWeight[student.srNo]?.weight
                        ? (heightWeight[student.srNo].weight / ((heightWeight[student.srNo].height / 100) ** 2)).toFixed(2)
                        : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonalData;